module.exports = __webpack_public_path__ + "static/playtime-8436259680ed1624068e5d19b7c28c8a.jpg";